import { Customer, HotListOrderItem, LabelImageType, PlasticsFinishingTaskStatus, PlasticsOrderedProduct, ProductVersion } from "@prism/prism-shared";

export interface PlasticsFinishingTask {
    id: string;
    productId: string;
    quantityToFinish: number;
    completedQuantity: number;
    note: string;
    warningMarkdown?: string;
    translatedWarningMarkdown?: string;
    status: PlasticsFinishingTaskStatus;
    /** retired - "being worked on" is now an open crew labor session on the task (FinishingLaborSessionsService) */
    activeWork: boolean;
    updatedById: string;
    updatedOn: Date;
    completedById: string | null;
    completedOn: Date | null;
    productVersionIdWhenCompleted: string;
    completedAtFinishingStationId: string | null;
    labelImageType: LabelImageType;
    purchaseOrderNumber: string;
    salesOrderNumber: string;
    labelProductDescription: string;
    endCustomerId: string;
    orderedProductId: string;
    hotListOrderItemId: string | null;
}


export interface DisplayPlasticsFinishingTask {
    task: PlasticsFinishingTask;
    version: ProductVersion;
    orderedProduct: PlasticsOrderedProduct | null;
    customer: Customer | null;
    hotListOrderItem?: HotListOrderItem | null;
}




export const toDisplayFinishingTasks = (
    tasks: PlasticsFinishingTask[],
    productIdToReleasedProductVersionDict: Record<string, ProductVersion>,
    customerDict: Record<string, Customer>,
    orderedProducts: PlasticsOrderedProduct[],
    hotListOrderItemDict: Record<string, HotListOrderItem> = {},
): DisplayPlasticsFinishingTask[] => {
    return tasks.map((task) => {
        const hotListOrderItem = task.hotListOrderItemId ? hotListOrderItemDict[task.hotListOrderItemId] || null : null;

        if (!task.orderedProductId) {
            return {
                task,
                version: productIdToReleasedProductVersionDict[task.productId],
                orderedProduct: null,
                customer: null,
                hotListOrderItem,
            }
        }
        const orderedProduct = orderedProducts.find(op => op.id === task.orderedProductId) as PlasticsOrderedProduct;
        if(!orderedProduct?.id){
            // console.log("orderedProduct",orderedProduct)
            // console.log("customerDict",customerDict)
        }
        const displayFinishingTask: DisplayPlasticsFinishingTask = {
            task,
            orderedProduct,
            version: productIdToReleasedProductVersionDict[task.productId],
            customer: customerDict[orderedProduct.customerId],
            hotListOrderItem,
        }
        return displayFinishingTask;
    })
        .sort((a, b) => {
            const aCompleted = a.task.status === PlasticsFinishingTaskStatus.Completed;
            const bCompleted = b.task.status === PlasticsFinishingTaskStatus.Completed;
            if (aCompleted && !bCompleted) {
                return 1;
            }
            if (!aCompleted && bCompleted) {
                return -1;
            }
            return 0;
        })

}
